import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import Map from "ol/Map";
import View from "ol/View";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import OSM from "ol/source/OSM";
import * as olProj from "ol/proj";
import TileLayer from "ol/layer/Tile";
import { AvanceTrabajoDTO } from "../../interfaces/avance-trabajo.interface";
import Geometry from "ol/geom/Geometry";
import VectorSource from "ol/source/Vector";
@Component({
    selector: "app-mapa",
    templateUrl: "./mapa.component.html",
    styleUrls: ["./mapa.component.scss"],
})
export class MapaComponent implements OnInit, AfterViewInit {
    @Input() avance: AvanceTrabajoDTO;
    map: Map;
    posicionAvance: Feature<Geometry>;
    vectorSource: VectorSource<Geometry>;
    vectorLayer: VectorLayer;
    constructor() {}
    ngAfterViewInit() {
        console.log(this.avance);

        this.posicionAvance = new Feature({
            geometry: new Point(
                olProj.fromLonLat([this.avance.longitud, this.avance.latitud])
            ),
        });

        this.posicionAvance.setStyle(
            new Style({
                image: new Icon({
                    //color: [113, 140, 0],
                    crossOrigin: "anonymous",
                    src: "assets/icons/red_marker.png",
                    //imgSize: [200, 200],
                }),
            })
        );

        this.vectorSource = new VectorSource({
            features: [this.posicionAvance],
        });

        this.vectorLayer = new VectorLayer({
            source: this.vectorSource,
        });

        this.map = new Map({
            target: "posicion_avance",
            layers: [
                new TileLayer({
                    source: new OSM(),
                }),
                this.vectorLayer,
            ],
            view: new View({
                center: olProj.fromLonLat([
                    this.avance.longitud,
                    this.avance.latitud,
                ]),
                zoom: 5,
            }),
        });
    }

    ngOnInit(): void {}
}
